import {
  Button as ButtonAntd,
  Col as ColAntd,
  DatePicker as DatePickerAntd,
  Row as RowAntd,
} from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

import colors from '../../../../../styles/colors';

export const Button = styled(ButtonAntd)`
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;

  &:hover {
    border: 1px solid ${colors.tmov_green};
  }
`;

export const ButtonHoje = styled(Button)`
  border-radius: 0 !important;
  border-left: 0px;
  border-right: 0px;
`;

export const ButtonAmanha = styled(Button)`
  border-radius: 0 !important;
`;

export const ButtonExtraStyle = {
  borderTopLeftRadius: 4,
  borderBottomLeftRadius: 4,
};

export const Row = styled(RowAntd)`
  width: 100%;
  margin: 20px 0;
  align-items: flex-start;
`;

export const Col = styled(ColAntd)`
  padding-right: 40px;
`;

const { RangePicker: RangePickerAntd } = DatePickerAntd;
export const RangePicker = styled(RangePickerAntd)`
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  border-left: 0;

  &:hover {
    border: 1px solid ${colors.tmov_green};
    border-left: 1px solid ${colors.tmov_green};
  }
`;

export const Styles = createGlobalStyle`
 .ant-picker-focused {
    border-color: ${colors.tmov_green} !important;
    border-left: 1px solid ${colors.tmov_green} !important;
    box-shadow: 0 0 0 0px rgba(24, 144, 255, 0.2) !important;
  }

  .btnAtivo {
    color: ${colors.white} !important;
    background: ${colors.tmov_green} !important;
    border: 1px solid ${colors.tmov_green} !important;

    &:hover {
      color: ${colors.white} !important;
    }
  }

  .btnInativo {
    color: ${colors.gray_2} !important;
    background: ${colors.white} !important;

    &:hover {
      color: ${colors.green} !important;
    }
  }

  @media only screen and (min-width: 1200px) {
    .margin-top-media {
      margin-top: 24px;
      text-align: end !important;
    }
  }

  @media only screen and (max-width: 1200px) {
    .margin-top-media {
      margin-bottom: 24px;
    }
  }

  .chart-custom {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .chart-custom-loading {
    width: 100%;
    margin-top: 10px;
    .recharts-wrapper {
      opacity: 0.5;
    }
  }
`;
